import classNames from 'classnames';
import { type FC } from 'react';

import CustomLink from '@/components/CustomLink';

import s from './TermsAndPolicy.module.scss';

const TermsAndPolicy: FC<{ isSignIn?: boolean; isCreatorView?: boolean }> = ({ isSignIn, isCreatorView = false }) => (
  <p
    className={classNames(s.wrapper, {
      [s.creatorWrapper]: isCreatorView,
      '!mt-2': true,
    })}
  >
    By signing {isSignIn ? 'in' : 'up'}, you agree to our{' '}
    <CustomLink to='https://www.glade.ai/terms-and-conditions'>Terms of use</CustomLink> and{' '}
    <CustomLink to='https://www.glade.ai/privacy-policy'>Privacy policy</CustomLink>.
  </p>
);

export default TermsAndPolicy;
